exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-color-picker span{color:rgba(0,0,0,.6)}.theme--dark.v-color-picker span{color:hsla(0,0%,100%,.7)}.v-color-picker{-ms-flex-item-align:start;align-self:flex-start;border-radius:4px;contain:content;-webkit-box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}", ""]);

// exports
